import $ from 'jquery'
import debounce from 'lodash/debounce'

export default () => {

    let siteCache = {

    }

    const themeDefaults = {
        breakPoints : [320, 768, 1024]
    }

    const initSiteCache = () => {

        siteCache = {
            $equalHeightEls: [
                $('.equal-heights'),
                $('.equal-heights--cards .card')
            ]
        }
    }

    const equalHeights = (_this) => {

        let currentTallest = 0
        _this.height("auto")

        _this.each(function(){
            let thisHeight = parseFloat($(this).css('height'))
            if (thisHeight > currentTallest) { currentTallest = thisHeight;}
        })

        if (Number.prototype.pxToEm) currentTallest = currentTallest.pxToEm()

        _this.css({'height': currentTallest})
        return this

    }

    const magicEqualHeights = (_this) => {

        let group = []

        _this.each(function(index) {
            group.push(this)
            let nextTop = _this.get(index + 1) ? $(_this.get(index + 1)).offset().top : false
            let thisTop = $(this).offset().top

            if (nextTop != thisTop) {
                equalHeights($(group))
                group = []
            }
        })

        equalHeights($(group))
    }

    const initEqualHeights = (breakPoint, $els) => {

        if(typeof $els === 'undefined'){
            $els = siteCache.$equalHeightEls
        }

        if(typeof breakPoint === 'undefined'){
            breakPoint = 0
        }

        const setHeight = debounce(function(){
            if($(this).width() >= themeDefaults.breakPoints[breakPoint]){
                $.each($els, function(){
                    magicEqualHeights($(this))
                    $(this).addClass('equal-heights-complete')
                })
            } else {
                $.each($els, function(){
                    $(this).height('auto')
                })
            }
        }, 300, true)

        setHeight()

        $(window).on('resize', function(){
            setHeight()
        })
    }

    initSiteCache()

    $(window).on('load', function(){
        initEqualHeights()
    })
}
